import moment from 'moment';
import isEmpty from 'helpers/isEmpty';
export default function formatTime(date, mask = 'HH:mm') {
  if (isEmpty(date)) return;
  return moment(new Date(date)).format(mask);
}
